import { HistoryEntry } from './history-entry';

export class HistoryJournal {
  currentIndex = 0;
  journal: HistoryEntry[] = [] as HistoryEntry[];

  isSelected(id: string) {
    if (
      this.journal &&
      this.journal[this.currentIndex] &&
      this.journal[this.currentIndex].id === id
    ) {
      return true;
    }
    return false;
  }

  canGoBack(): boolean {
    if (this.journal && this.journal.length > 1 && this.currentIndex !== 0) {
      return true;
    }
    return false;
  }
}
